import React from "react";
import styles from "./WhatsAppFloat.module.css";
import whatsappIcon from "../../assets/WhatsApp_icon.webp"; // local icon use karo

export default function WhatsAppFloat({
  phoneNumber = "919971881444",
  message = "Hi, My name is [Your Name], I'm interested in your [Package Name] package. Please share details.",
  label = "Plan your trip",
}) {
  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <a
      href={whatsappLink}
      className={styles.container}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className={styles.label}>{label}</span>

      <img
        src={whatsappIcon}
        alt="WhatsApp"
        className={styles.icon}
      />
    </a>
  );
}